/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Letterpreviewsignoffpt4Inputs */

const en_letterpreviewsignoffpt4 = /** @type {(inputs: Letterpreviewsignoffpt4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Com os melhores cumprimentos,`)
};

const pt_letterpreviewsignoffpt4 = /** @type {(inputs: Letterpreviewsignoffpt4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Com os melhores cumprimentos,`)
};

/**
* | output |
* | --- |
* | "Com os melhores cumprimentos," |
*
* @param {Letterpreviewsignoffpt4Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const letterpreviewsignoffpt4 = /** @type {((inputs?: Letterpreviewsignoffpt4Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Letterpreviewsignoffpt4Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_letterpreviewsignoffpt4(inputs)
	return pt_letterpreviewsignoffpt4(inputs)
});
export { letterpreviewsignoffpt4 as "letterPreviewSignoffPT" }